export enum FormMode {
  None,
  Create,
  Update,
  Read,
}
